<template>
  <div class="common-page order-reassignment">
    <!--    <div class="line-separate"></div>-->
    <div class="left-box-content">
      <div class="right-top">
        <div>
          <el-input
            class="right-search"
            style="width: 100%"
            clearable
            @input="handleChangeDriverSearch"
            v-model="searchForm.keyword"
            autocomplete="off"
            suffix-icon="el-icon-search"
            placeholder="请输入司机姓名或手机号码"></el-input>
        </div>
        <div>
          <el-checkbox v-model="searchForm.onlyNoEarnings" @change="handleChangeDriverSearch">
            查看无收益司机
          </el-checkbox>
        </div>
      </div>
      <div class="right-center-box" v-loading="diverLoading">
        <template v-if="userList && userList.length > 0">
          <div
            class="center-box"
            v-for="(item, index) in userList"
            :key="item.id"
            :class="item.id === selectUserId ? 'selectTab' : ''"
            @click="handleClick(item, index)">
            <div class="center-box-1">
              <div class="list-1">
                <el-image :src="cheImage" class="label-img"></el-image>
                <span class="center-name">{{ item.carNumber }}</span>
              </div>
              <div class="list-2">
                {{ item.vehicleMode }}
              </div>
              <div class="list-3">{{ item.vehicleLength }}米</div>
            </div>
            <div class="center-box-2">
              <div>
                <span class="box-value">{{ item.companyName }}</span>
                <span class="box-value pl10">{{ item.username }}</span>
                <span class="box-value pl10">{{ item.phone }}</span>
              </div>
              <div>
                <span class="box-value">司机入住时间：</span>
                <span>{{ item.auditTime }}</span>
              </div>
            </div>
          </div>
        </template>
        <div class="no-data" v-else>
          <el-empty :image-size="100" description="暂无司机信息"></el-empty>
        </div>
      </div>
    </div>
    <div class="right-content">
      <div class="left-box">
        <div class="left-box-content1">
          <div class="content-box1">
            <div class="search-form-box">
              <div class="list-bottom">
                <div class="list-bottom-box">
                  <div class="bottom-box-name">派单</div>
                  <div class="bottom-box-value">{{staticsData.orderNum }}</div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">履约</div>
                  <div class="bottom-box-value">{{staticsData.completeNum}}</div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">累计</div>
                  <div class="bottom-box-value">￥{{staticsData.fee}}</div>
                </div>
                <div class="list-bottom-box">
                  <div class="bottom-box-name">日均</div>
                  <div class="bottom-box-value">￥{{staticsData.avgFee}}</div>
                </div>
              </div>
            </div>
            <div
              class="custom-table-box"
              v-loading="tableOptions.loading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255,0.8)">
              <template v-if="tableData && tableData.length > 0">
                <div
                  class="table-list"
                  :class="
                  item.orderId === selectOrderId ? 'table-list-select' : ''
                "
                  v-for="(item, index) in tableData"
                  :key="item.orderId"
                  @click="handleSelectOrder(item, index)">
                  <div class="list-content-left">
                    <div class="list-top">
                      <div class="list-top-left">
                        <div class="list-box" v-for="(item2, index) in item.points" :key="index">
                          <div class="list-box-top">
                            <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
                              {{ item2.loadType === 1 ? "装" : "卸" }}
                            </div>
                            <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="list-top-des">
                      <span>订单类型</span>
                      ：
                      <span v-if="item.orderSource === 1">平台订单</span>
                      <span v-if="item.orderSource === 2">三方订单</span>
                    </div>
                    <div class="list-top-des">
                      <span>订单状态</span>
                      ：
                      <span class="list-status-label status-error1" v-if="item.orderStatus === 1">待支付</span>
                      <span class="list-status-label status-pending-order1" v-if="item.orderStatus === 10">待派单</span>
                      <span class="list-status-label status-pending-order1" v-if="item.orderStatus === 20">运输中</span>
                      <span class="list-status-label status-confirm1" v-if="item.orderStatus === 100">已完成</span>
                      <span class="list-status-label status-cancel1" v-if="item.orderStatus === 0">已取消</span>
                    </div>
                  </div>
                </div>
              </template>
              <div class="no-data" v-else>
                <el-empty :image-size="100" description="暂无订单"></el-empty>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box" v-loading="loading">
        <div class="right-content" v-if="selectOrderId">
          <div class="list-top">
            <div class="list-top-left">
              <div class="left1-box" v-for="(item2, index) in detail.pointList" :key="index">
                <div class="left1-box-top">
                  <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
                    {{ item2.loadType === 1 ? "装" : "卸" }}
                  </div>
                  <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
                </div>
                <div class="date">
                  <div>{{ $day.fd(item2.startTime, item2.endTime) }}</div>
                </div>
              </div>
            </div>
            <div class="list-top-right">
              <div class="right-money">
                <span class="money">{{ detail.fee || "-" }}</span>
                <span class="unit">元/趟</span>
              </div>
              <div class="right-ding">
                <span class="ding">订金</span>
                ：{{detail.deposit || "-"}}元(可退)
              </div>
            </div>
          </div>
          <div class="list-box">
            <div class="list-bottom">
              <div class="list-bottom-box">
                <div class="bottom-box-name">物品</div>
                <div class="bottom-box-value">
                  {{ detail?.cargo?.cargoName || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">重量</div>
                <div class="bottom-box-value">
                  {{ detail?.cargo?.weight || "-" }}
                  {{ detail?.cargo?.wightUnit === 1 ? "吨" : "公斤" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">体积</div>
                <div class="bottom-box-value">{{ detail?.cargo?.volume || "-" }}㎡</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">包装方式</div>
                <div class="bottom-box-value">
                  {{ detail?.cargo?.packingWays || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">用车要求</div>
                <div class="bottom-box-value">
                  {{ detail?.vehicleUseType || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车型</div>
                <div class="bottom-box-value">
                  <custom-tooltip-multiple :text="detail?.vehicle?.vehicleMode"></custom-tooltip-multiple>
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车长</div>
                <div class="bottom-box-value">
                  <custom-tooltip-multiple :text="detail?.vehicle?.vehicleLength"></custom-tooltip-multiple>
                </div>
              </div>
            </div>
            <div class="list-bottom">
              <div class="list-bottom-box">
                <div class="bottom-box-name">发票</div>
                <div class="bottom-box-value">
                  {{ detail.needInvoice ? "需要" : "不需要" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">回单</div>
                <div class="bottom-box-value">
                  {{ getLocalLabel("receiptType", detail.receiptType) }}
                </div>
              </div>

              <div class="list-bottom-box">
                <div class="bottom-box-name">公里数</div>
                <div class="bottom-box-value">{{ detail.kilometre || "-" }}km</div>
              </div>

              <div class="list-bottom-box">
                <div class="bottom-box-name">技术服务费</div>
                <div class="bottom-box-value" v-if="detail.orderSource === 1">{{ detail.technicalFee || "-" }}元</div>
                <div class="bottom-box-value" v-if="detail.orderSource === 2">
                  {{ detail.technicalFee + detail.platformCommission }}元
                </div>
              </div>
              <div class="list-bottom-box list-bottom-box3" v-if="detail.remark">
                <div class="bottom-box-name">备注</div>
                <div class="bottom-box-value" style="text-align: left">
                  <custom-tooltip :text="detail.remark"></custom-tooltip>
                </div>
              </div>
            </div>
            <div class="list-bottom-img">
              <div class="list-bottom">
                <div class="list-bottom-box" v-for="(item, index) in detail?.cargo?.pictures" :key="index">
                  <el-image :src="item" class="list-image"></el-image>
                </div>
              </div>
            </div>
          </div>
          <div class="list-status">
            <div class="list-carInfo">
              <order-status-step :details="detail"></order-status-step>
              <template v-if="detail?.driver">
                <div class="title-box">
                  <el-image :src="cheImage" class="title-label"></el-image>
                  司机承运信息
                </div>
                <div class="list-box">
                  <div class="list-bottom">
                    <div class="list-bottom-box list-bottom-box5">
                      <el-image :src="siJiImage" class="siji-image"></el-image>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">司机姓名</div>
                      <div class="bottom-box-value">
                        {{ detail?.driver?.username || "-" }}
                      </div>
                    </div>
                    <div class="list-bottom-box list-bottom-box2">
                      <div class="bottom-box-name">联系电话</div>
                      <div class="bottom-box-value">
                        {{ detail?.driver?.phone || "-" }}
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">车牌号码</div>
                      <div class="bottom-box-value">
                        {{ detail?.driver?.carNumber || "-" }}
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">所属机构</div>
                      <div class="bottom-box-value">
                        {{ detail?.driver?.companyName || "-" }}
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">关联车队长</div>
                      <div class="bottom-box-value color1269FF">
                        {{ detail?.driver?.vehicleLeaderName || "-" }}
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">关联调度</div>
                      <div class="bottom-box-value color1269FF">
                        {{ detail?.driver?.dispatcherName || "-" }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="title-box">
                <el-image :src="cheImage" class="title-label"></el-image>
                订单基础信息
              </div>
              <div class="list-box">
                <div class="list-bottom">
                  <div class="list-bottom-box list-bottom-box5">
                    <el-image :src="dngDanImage" class="ding-image"></el-image>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">订单归属</div>
                    <div class="bottom-box-value">
                      <custom-tooltip :text="detail?.companyName"></custom-tooltip>
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">货主姓名</div>
                    <div class="bottom-box-value">
                      <custom-tooltip :text="detail?.ownerName"></custom-tooltip>
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">联系方式</div>
                    <div class="bottom-box-value">
                      <custom-tooltip :text="detail?.ownerPhone"></custom-tooltip>
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">下单方式</div>
                    <div class="bottom-box-value">
                      {{ getLocalLabel("orderFrom", detail?.orderFrom) }}
                    </div>
                  </div>
                  <div class="list-bottom-box list-bottom-box4">
                    <div class="bottom-box-name">订单编号</div>
                    <div class="bottom-box-value">
                      <custom-tooltip :text="detail?.orderNo"></custom-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="no-data" v-else>
          <el-empty :image-size="100" description="点击左侧订单查询详情"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocalLabel } from "@/utils/localDict";
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
import detail from "@/views/OrderManagement/stepDetail.vue";
import orderStatusStep from "@/components/orderStatusStep.vue";
import {getNewDriverPage, getOrderNewDriver} from "./api";
import {debounce} from "lodash";
export default {
  name: "NewDriverOrderFollowUp",
  components: {
    detail,
    CustomTooltip,
    orderStatusStep,
    CustomTooltipMultiple,
    OperateBox,
    CustomTable,
  },
  data() {
    return {
      loading: false,
      detail: {},
      cheImage: require("@/assets/imgs/title.png"),
      detailImage: require("@/assets/imgs/title.png"),
      siJiImage: require("@/assets/imgs/siji.png"),
      dngDanImage: require("@/assets/imgs/dngdan.png"),
      selectDriverLabel: "myDriver",
      isOver: false,
      searchForm: {
        keyword: "",
        onlyNoEarnings: false,
      },
      tableOptions: {
        loading: false,
      },
      selectOrderId: "",
      selectUserId: "",
      userList: [],
      tableData: [],
      staticsData: {},
      stepData: [],
      selectTab: 1,
      diverLoading: false,
    };
  },
  watch: {
    selectUserId: function (val) {
      this.getOrderData()
    }
  },
  created() {},
  mounted() {
    this.getDriverData()
  },
  methods: {
    getLocalLabel,
    handleChangeDriverSearch: debounce(function (val) {
      this.getDriverData();
    }, 500),
    getDriverData() {
      this.diverLoading = true;
      getNewDriverPage({
        keyword: this.searchForm.keyword,
        onlyNoEarnings: this.searchForm.onlyNoEarnings,
      }).then((res) => {
        if (res.code === 200) {
          this.userList = res.data
        }
      }).finally(()=>{
        this.diverLoading = false
      })
    },
    getOrderData() {
      this.tableOptions.loading = true;
      getOrderNewDriver({
        driverId: this.selectUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.orders
          this.staticsData = res.data
        }
      }).finally(()=>{
        this.tableOptions.loading = false
      })
    },
    handleClick(item, index) {
      this.selectUserId = item.id;
    },
    refreshData() {
      this.tableOptions.currentPage = 1;
      this.getTableData();
    },
    handleSizeChangeS(val) {
      this.tableOptions.pageSize = val;
      this.getTableData();
    },
    handleSizeChangeC(val) {
      this.tableOptions.currentPage = val;
      this.getTableData();
    },
    isCheckDetail(stepStatus, stepType) {
      // 1货主下单，2客服代下单，5货主支付，10调度派单，11订单改派，21装货点装货，22卸货点卸货，31订单取消，41订单退款
      let arr = [5, 10, 11, 21, 22, 31, 41];
      if (stepStatus === 0) {
        return false;
      } else {
        if (arr.includes(stepType)) {
          return true;
        }
        return false;
      }
    },
    handleCheckDetail(item) {
      this.$refs.detail.init(item);
    },
    handleChangeTab(val) {
      this.selectTab = val;
    },
    handleCreateOrder() {
      this.$refs.addOrEdit.init();
    },
    openDetail(item) {
      this.$refs.detail.init(item);
    },
    handleChange(val) {
      this.selectTab = val;
      this.$emit("changeTab", this.selectTab);
    },
    handleSelectOrder(item, index) {
      this.selectOrderId = item.orderId;
      this.getOrderDetail(item.orderId);
    },
    getOrderDetail(orderId) {
      this.loading = true;
      detailInfo(orderId)
          .then((res) => {
            this.loading = false;
            if (res.code === 200) {
              this.detail = res.data;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>
<style lang="scss" scoped>
.order-reassignment {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: row;
  .left-box-content {
    width: 3rem;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    //padding-right: 0.2rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 0.08rem;
    margin-right: 0.2rem;
    .right-top {
      height: 0.7rem;
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      .right-title {
        padding: 0.2rem 0 0;
        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }
      .right-search {
        margin: 0.2rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;
      //padding-right: 0.2rem;

      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        padding: 0.1rem;
        box-sizing: border-box;
        .center-box-1 {
          display: flex;
          align-items: center;
          margin-bottom: 0.08rem;
          .list-1 {
            display: flex;
            align-items: center;

            .label-img {
              width: 0.14rem;
              height: 0.14rem;
            }
            .center-name {
              line-height: 0.2rem;
              padding-left: 0.04rem;
              color: #000000;
              font-size: 0.14rem;
            }
          }
          .list-2,
          .list-3 {
            font-size: 0.12rem;
            color: #000000;
          }
          .list-2 {
            padding: 0 0.2rem;
            position: relative;
            &::before {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              left: 0.1rem;
            }
            &::after {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              right: 0.1rem;
            }
          }
        }
        .center-box-2 {
          color: #8c8c8c;
          font-size: 0.12rem;
          line-height: 0.26rem;

          .box-value {
            color: #434343;
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
        background-color: rgba(18, 105, 255, 0.05);
      }
    }
  }
  .right-content{
    flex: 1;
    display: flex;
  }
  .left-box {
    box-sizing: border-box;
    width: 4.5rem;
    flex-shrink: 0;
    .left-box-content1 {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0.2rem 0.2rem 0.2rem 0;
      box-sizing: border-box;
      border-radius: 0.08rem;

      .custom-table-box {
        //max-height: 90%;
        overflow-y: auto;
        padding-top: 0;

        .table-list {
          width: 100%;
          background: #fbfcff;
          margin-bottom: 0.2rem;
          padding: 0.12rem 0.1rem;
          box-sizing: border-box;
          border: 0.01rem solid #fbfcff;
          border-radius: 0.08rem;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          position: relative;

          .list-content-left {
            flex: 1;
            .list-top-des{
              line-height: 1.5;
              padding-top: 0.05rem;
              span:nth-of-type(1){
                color: rgba(0,0,0,0.5);
              }
            }
            .list-status-label {
              padding: 0.08rem 0.12rem;
              font-size: 0.12rem;
              border-radius: 0 0.08rem 0 0.08rem;
              position: absolute;
              top: 0;
              right: 0;
            }

            .list-date-box {
              padding-bottom: 0.15rem;

              .create-time {
                padding-right: 0.1rem;
              }
            }
          }

          .list-content-right {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-shrink: 0;
            padding-top: 0.1rem;
            box-sizing: border-box;
            padding-left: 0.2rem;

            .right-default {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #eaf1ff;
              color: #1269ff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 0.1rem;
            }

            .right-primary {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #1269ff;
              color: #ffffff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .list-top {
            display: flex;
            justify-content: space-between;

            .list-top-left {
              display: flex;

              .list-box {
                padding-right: 0.5rem;
                position: relative;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                .list-box-top {
                  display: flex;
                  align-items: center;

                  .label {
                    flex-shrink: 0;
                    width: 0.2rem;
                    height: 0.2rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0.02rem;
                    font-size: 0.12rem;
                  }

                  .zhuang {
                    color: #5cc41a;
                    background-color: rgba(92, 196, 26, 0.3);
                  }

                  .xie {
                    color: #e52019;
                    background-color: rgba(229, 32, 25, 0.3);
                  }

                  .name {
                    color: #000000;
                    font-size: 0.18rem;
                    line-height: 0.2rem;
                    padding-left: 0.04rem;
                  }
                }

                .date {
                  color: #8c8c8c;
                  font-size: 0.12rem;
                  line-height: 0.2rem;
                }
              }
              .list-box:nth-of-type(2n){
                padding-right: 0;
              }
              .list-box::before {
                content: "→";
                position: absolute;
                right: 0.15rem;
                top: 0.04rem;
                color: #52c41a;
              }

              .list-box:nth-last-of-type(1)::before {
                display: none;
              }
            }

            .list-top-right {
              .right-ding {
                font-size: 0.12rem;

                .ding {
                  color: #eeeeee;
                }
              }

              .right-money {
                display: flex;
                justify-content: right;
                align-items: baseline;
                color: #faad14;

                .unit {
                  font-size: 0.12rem;
                  padding-left: 0.04rem;
                }
              }

              .right-box2 {
                display: flex;
                align-items: center;

                .right-box2-time {
                  font-size: 0.12rem;
                  line-height: 0.2rem;
                  color: #8c8c8c;
                  margin-right: 0.1rem;
                }

                .right-box2-label {
                  background-color: #fff7e6;
                  color: #fa8c16;
                  font-size: 0.12rem;
                  line-height: 0.22rem;
                  border-radius: 0.1rem;
                  padding: 0 0.1rem;
                }
              }
            }
          }

          .list-bottom {
            width: 100%;
            display: flex;
            padding: 0.2rem 0 0;

            .list-bottom-box {
              width: 25%;
              display: flex;
              flex-direction: column;
              position: relative;
              padding-left: 0.1rem;
              box-sizing: border-box;

              .bottom-box-name {
                color: #8c8c8c;
                font-size: 0.12rem;
                margin-bottom: 0.1rem;
              }

              .bottom-box-value {
                color: #434343;
                font-size: 0.14rem;
              }
            }

            .list-bottom-box::before {
              content: "";
              position: absolute;
              right: 0;
              top: 0.08rem;
              width: 0.01rem;
              height: 0.26rem;
              background-color: #dce5f5;
            }

            .list-bottom-box:nth-last-of-type(1)::before {
              display: none;
            }
          }

          .car-box {
            display: flex;
            align-items: center;
            border-top: 0.01rem dashed #dce5f5;
            padding: 0.1rem 0 0;

            .list-1 {
              display: flex;
              align-items: center;

              .label-img {
                width: 0.14rem;
                height: 0.14rem;
              }

              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
                font-size: 0.14rem;
                color: #52c41a;
              }
            }

            .list-2,
            .list-3 {
              font-size: 0.12rem;
              color: #8c8c8c;
            }

            .list-2 {
              padding: 0 0.2rem;
              position: relative;

              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }

              &::after {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
              }
            }
          }
        }

        .table-list-select {
          border-color: #1269ff;
          background-color: rgba(18, 105, 255, 0.05);
        }
      }

      .pagination-box {
        display: flex;
        justify-content: right;
        padding: 0.2rem 0.2rem 0.2rem 0;
        background-color: #fff;
      }
    }
  }

  .search-form-box {
    padding-top: 0;
    flex-shrink: 0;
    .list-bottom {
      width: 100%;
      display: flex;
      padding: 0.2rem 0 0.2rem;


      .list-bottom-box {
        width: 25%;
        display: flex;
        flex-direction: column;
        position: relative;
        padding-left: 0.1rem;
        box-sizing: border-box;

        .bottom-box-name {
          color: #8c8c8c;
          font-size: 0.14rem;
          margin-bottom: 0.1rem;
        }

        .bottom-box-value {
          color: #434343;
          font-size: 0.16rem;
        }
      }

      .list-bottom-box::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0.08rem;
        width: 0.01rem;
        height: 0.26rem;
        background-color: #dce5f5;
      }

      .list-bottom-box:nth-last-of-type(1)::before {
        display: none;
      }
    }
  }

  .custom-table-box {
    flex: 1;
  }

  .pagination-box {
    position: sticky;
    bottom: 0;
  }

  .right-box {
    flex: 1;
    padding: 0.2rem;
    box-sizing: border-box;

    .right-content {
      height: 100%;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }
  }

  .money {
    font-size: 0.18rem;
    color: #faad14;
  }

  .right-box {
    width: 30%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    padding: 0.2rem 0.2rem 0.2rem 0;

    .right-top {
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      padding-top: 0.2rem;

      .right-title {
        padding: 0.2rem 0 0;

        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }

      .right-title-tip {
        color: rgba(0, 0, 0, 0.25);
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding: 0.1rem 0;
      }

      .right-search {
        margin: 0.15rem 0 0;
      }

      .sort-car {
        padding: 0.1rem 0;
      }
    }

    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;
      padding-top: 0.2rem;

      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        padding: 0 0.1rem;
        box-sizing: border-box;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        overflow: hidden;
        position: relative;

        .label-box {
          position: absolute;
          right: 0;
          top: 0;
          border-radius: 0 0 0 0.08rem;

          width: 0.79rem;
          height: 0.29rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.12rem;
        }

        .label-box1 {
          background: rgba(250, 173, 20, 0.15);
          color: #faad14;
        }

        .label-box2 {
          background: rgba(82, 196, 26, 0.15);
          color: #52c41a;
        }

        .label-box3 {
          background: rgba(18, 105, 255, 0.15);
          color: #1269ff;
        }

        .center-box-name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.1rem 0;

          .left-box {
            display: flex;
            align-items: center;

            .center-box-1 {
              display: flex;
              align-items: center;

              .label-name {
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1269ff;
                font-size: 0.12rem;
                background-color: rgba(18, 105, 255, 0.05);
              }

              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }

            .center-box-2 {
              display: flex;
              align-items: center;
              line-height: 0.24rem;
              color: #000000;
              font-size: 0.12rem;
              position: relative;
            }

            .center-box-2 {
              padding-left: 0.2rem;
              position: relative;

              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
            }
          }

          .center-box-3 {
            flex-shrink: 0;
            line-height: 0.2rem;
            font-size: 0.16rem;

            .default-icon {
              color: #eeeeee;
            }

            .selected-icon {
              color: #52c41a;
            }
          }
        }

        .center-box-car {
          border-top: 0.01rem dashed #dce5f5;

          .car-list {
            display: flex;
            align-items: center;
            padding: 0.08rem 0;

            .center-box-2 {
              padding-right: 0.2rem;
              color: #8c8c8c;
              position: relative;
              font-size: 0.12rem;

              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
                top: 0.02rem;
              }
            }

            .center-box-2:nth-last-of-type(1)::before {
              display: none;
            }
          }
        }

        .car-operate {
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0.1rem 0;
          background-color: #f4f6fd;
          margin: 0 -0.1rem;

          .operate-list {
            display: flex;
            align-items: center;
            position: relative;

            .operate-img {
              width: 0.14rem;
              height: 0.14rem;
              margin-right: 0.02rem;
            }

            .operate-txt {
              font-size: 0.12rem;
              color: #434343;
            }
          }

          .operate-line {
            width: 0.01rem;
            height: 0.14rem;
            background-color: #e3e7ed;
          }
        }
      }

      .selectTab {
        border: 0.01rem solid #1269ff;
      }
    }

    .right-bottom-operate {
      width: 100%;
      flex-shrink: 0;
      position: sticky;
      bottom: 0rem;
      background-color: #ffffff;
      display: flex;
      justify-content: right;
      padding: 0.15rem 0;
      box-sizing: border-box;
      border-top: 0.01rem solid #e3e7ed;
    }

    .right-content {
      height: 100%;
      padding: 0.2rem 0.16rem;
      box-sizing: border-box;

      .list-top {
        display: flex;
        justify-content: space-between;

        .list-top-left {
          display: flex;

          .left1-box {
            padding-right: 0.5rem;
            position: relative;

            .left1-box-top {
              display: flex;
              align-items: center;

              .label {
                flex-shrink: 0;
                width: 0.2rem;
                height: 0.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.02rem;
                font-size: 0.12rem;
              }

              .zhuang {
                color: #5cc41a;
                background-color: rgba(92, 196, 26, 0.3);
              }

              .xie {
                color: #e52019;
                background-color: rgba(229, 32, 25, 0.3);
              }

              .name {
                color: #000000;
                font-size: 0.18rem;
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }

            .date {
              color: #8c8c8c;
              font-size: 0.12rem;
              line-height: 0.2rem;
            }
          }

          .left1-box::before {
            content: "→";
            position: absolute;
            right: 0.15rem;
            top: 0.04rem;
            color: #52c41a;
          }

          .left1-box:nth-last-of-type(1)::before {
            display: none;
          }
        }

        .list-top-right {
          .right-money {
            display: flex;
            justify-content: right;
            align-items: baseline;
            color: #faad14;

            .money {
              font-size: 0.18rem;
              padding-bottom: 0.06rem;
            }

            .unit {
              font-size: 0.12rem;
              padding-left: 0.04rem;
            }
          }

          .right-box2 {
            display: flex;
            align-items: center;

            .right-box2-time {
              font-size: 0.12rem;
              line-height: 0.2rem;
              color: #8c8c8c;
              margin-right: 0.1rem;
            }

            .right-box2-label {
              background-color: #fff7e6;
              color: #fa8c16;
              font-size: 0.12rem;
              line-height: 0.22rem;
              border-radius: 0.1rem;
              padding: 0 0.1rem;
            }
          }
        }
      }

      .list-box {
        background: #f7fbff;
        border-radius: 0.08rem;
        padding: 0.1rem;
        box-sizing: border-box;
        margin-top: 0.2rem;

        .list-bottom {
          width: 100%;
          display: flex;
          padding: 0.08rem 0;
          box-sizing: border-box;

          .list-bottom-box {
            width: 14%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            box-sizing: border-box;

            .list-image {
              width: 0.6rem;
              height: 0.6rem;
              border-radius: 0.05rem;
            }

            .bottom-box-name {
              color: #8c8c8c;
              font-size: 0.12rem;
              margin-bottom: 0.06rem;
            }

            .bottom-box-value {
              color: #434343;
              font-size: 0.14rem;
              text-align: center;
            }
          }

          .list-bottom-box3 {
            width: 40%;
            align-items: flex-start;
            padding-left: 5%;
            box-sizing: border-box;
          }

          .list-bottom-box2 {
            width: 20%;
          }

          .list-bottom-box::before {
            content: "";
            position: absolute;
            right: 0;
            top: 0.06rem;
            width: 0.01rem;
            height: 0.26rem;
            background-color: #dce5f5;
          }

          .list-bottom-box:nth-last-of-type(1)::before {
            display: none;
          }

          .list-bottom-box4 {
            width: 35%;
          }

          .list-bottom-box5 {
            width: 10%;
          }
        }

        //.list-bottom2 {
        //  .list-bottom-box:nth-last-of-type(1):before,
        //  .list-bottom-box:nth-last-of-type(2):before,
        //  .list-bottom-box:nth-last-of-type(3):before,
        //  .list-bottom-box:nth-last-of-type(4):before {
        //    display: none;
        //  }
        //}
      }

      .siji-image,
      .ding-image {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }

  .tab-box {
    margin-bottom: 0.2rem;
  }

  .content-box1 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .to-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0 0.16rem;
      box-sizing: border-box;
    }
  }

  .content-box2 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 0 0.2rem;
    box-sizing: border-box;
  }

  .list-bottom-img {
    .list-bottom {
      padding-left: 0.3rem !important;
    }

    .list-bottom-box {
      width: auto !important;
    }

    .list-bottom-box:before {
      display: none;
    }

    .list-image {
      margin-right: 0.1rem;
    }
  }

  .list-status {
    .title-box {
      padding: 0.2rem 0 0;

      .title-label {
        width: 0.08rem;
        height: 0.08rem;
        margin-right: 0.06rem;
      }
    }

    .list-label {
      padding: 0.1rem 0;
    }

    .color8c8c8c {
      color: #8c8c8c;
    }

    .color434343 {
      color: #434343;
    }

    .bgEDF4FF {
      background-color: #edf4ff;
    }
  }

  .siji-image,
  .ding-image {
    width: 0.2rem;
    height: 0.2rem;
  }
}
</style>
